<!-- <sca-dashboard></sca-dashboard> -->
<!-- <div *ngFor="let day of schedule">
  <h3>{{ day.date | date : "fullDate" }}</h3>

  <div *ngFor="let event of day.events" class="event">
    <div class="event-header">
      <img [src]="event.userIconUrl" alt="icon" class="icon" />
      <strong>{{ event.topic }}</strong>
    </div>

    <div class="event-time">
      {{ event.startTime || "" }} - {{ event.endTime || "" }}
    </div>

    <div *ngIf="event.speakerFirstName || event.speakerLastName">
      <span class="speaker">
        {{ event.speakerTitle }} {{ event.speakerFirstName }}
        {{ event.speakerLastName }}
      </span>
    </div>
  </div>

  <hr />
</div> -->
<!-- <div *ngIf="pages.length > 0; else noPages">
  <ul class="list-group">
    <li class="list-group-item" *ngFor="let page of pages">
      <h5>{{ page.title }}</h5>
      <p>{{ page.content }}</p>
    </li>
  </ul>
</div>

<ng-template #noPages>
  <p>No pages found for this category.</p>
</ng-template> -->

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="pages" class="mat-table full-width-table">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let page">{{ page.name }}</td>
    </ng-container>

    <!-- Title Column -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let page">{{ page.title }}</td>
    </ng-container>

    <!-- Sort Column -->
    <ng-container matColumnDef="sort">
      <th mat-header-cell *matHeaderCellDef>Sort</th>
      <td mat-cell *matCellDef="let page">{{ page.sort }}</td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let page">
        <button mat-button color="primary" (click)="onEdit(page)">Edit</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-divider class="mt-4 mb-2"></mat-divider>
  <p *ngIf="pages.length === 0">No pages found for this category.</p>
</div>